import TestYourApp from 'src/containers/TestYourApp/TestYourApp';

export default TestYourApp;